import React from 'react';

import PropTypes from 'prop-types';
import { MdInfo } from 'react-icons/md';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';

import { Alert } from '@shared';
import { Button } from '@shared/components';

import { offlineSel, openSyncModal, pendingRequestsCountSel } from '../../duck';
import styles from './SyncPendingBanner.less';

const SyncPendingBanner = ({ itemCount, onOpenSyncModal, isOffline }) =>
  !isOffline &&
  !!itemCount && (
    <Alert
      className={styles.banner}
      type="info"
      banner
      showIcon={false}
      message={
        <React.Fragment>
          <div className={styles.alertText}>
            <MdInfo className={styles.alertIcon} />
            <FormattedMessage id="offline.SyncPendingBanner.text" />
          </div>
          <div className={styles.alertButton}>
            <Button
              ghost
              uppercase
              noBorder
              color="info"
              size="small"
              onClick={onOpenSyncModal}
            >
              <FormattedMessage id="offline.SyncPendingBanner.button" />
            </Button>
          </div>
        </React.Fragment>
      }
    />
  );

SyncPendingBanner.propTypes = {
  itemCount: PropTypes.number.isRequired,
  isOffline: PropTypes.bool.isRequired,
  onOpenSyncModal: PropTypes.func.isRequired,
};

const mapState = state => ({
  itemCount: pendingRequestsCountSel(state),
  isOffline: offlineSel(state),
});

const mapDispatch = dispatch => ({
  onOpenSyncModal: () => dispatch(openSyncModal()),
});

export default connect(mapState, mapDispatch)(SyncPendingBanner);
